export const selectItineraryResultsRegions = (state) =>
  state?.voyagePlanner?.itineraryResults?.voyageSearch?.data?.regions || [];
